import { SelectedTime } from '../../../../ui/gzTimePicker/types';

export interface EasmScanConfigurationSchedulerSchema {
  // all the data needed for rendering
  title?: string;
  recurrence?: string;
  lastScanDate: string;
  nextScheduledScan: string;
  isActive: boolean;
  weeklyRecurrence?: WeeklyRecurrence;
  start: SelectedTime;
}

export interface WeeklyRecurrence {
  day: number;
}

export enum EASMSchedulerEvents {
  DAY_PICKER_EMPTY = 'dayPickerEmpty',
  DAY_PICKED = 'dayPicked',
}

export enum WeekDays {
  Monday = 0,
  Tuesday = 1,
  Wednesday = 2,
  Thursday = 3,
  Friday = 4,
  Saturday = 5,
  Sunday = 6,
}
